import { useEnumStore } from '@stores/enum';
import { setupParameters } from '@utils/parameters';

export default function (parameters = [], valueIds = null) {
  const enums = useEnumStore();
  const route = useRoute();
  return setupParameters(enums.catalogueParameters || [], parameters, route.query, 'c', valueIds);
}
